import { checkCompatibility } from "@/generated/TradingGateway"
import { log } from "@/utils"

export function checkTradingGatewayCompatibility() {
  checkCompatibility().subscribe((response) => {
    const logFn = response.type === "incompatible" ? log.error : log
    logFn(`Trading Gateway Api is ${response.type}`)
    if (response.type === "incompatible") {
      response.payload.methods.map(
        ({
          method: { methodName, serviceName, methodRouteKey },
          reason: { type },
        }) => logFn(`${type} ${serviceName} ${methodName} ${methodRouteKey}`),
      )
    }
  })
}
